<script setup>
import { ref } from "vue"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import store from "../../state/store"
import OccasionsTable from "./OccasionsTable.vue"


const title = "مدیریت مناسبت ها"
const items = ref([
  {
    text: "داشبورد",
    href: "/",
  },
  {
    text: "مدیریت مناسبت ها",
    active: true,
  },
])


const occasionModel = ref({})

function editOccasion(cat) {
  store.dispatch("getOccasion", cat.id).then(({ data }) => {
    occasionModel.value = data.data
    // showAddNewModal()
  })
}

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col lg="12">
        <b-card no-body id="occasionList">
          <b-card-header class="border-bottom-dashed">
            <b-row class="g-4 align-items-center">
              <b-col sm>
                <div>
                  <h5 class="card-title mb-0">لیست مناسبت ها</h5>
                </div>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                  <router-link
                    class="btn btn-success add-btn me-1"
                    id="create-btn"
                    :to="{ name: 'occasion.add' }"
                  >
                    <i class="ri-add-line align-bottom me-1"></i> افزودن مناسبت
                    جدید
                  </router-link>
                </div>
              </b-col>
            </b-row>
          </b-card-header>

          <!-- occasions table  -->

          <OccasionsTable @clickEdit="editOccasion" />

        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<style>
.multiselect-clear {
  padding: 0 0 0 var(--ms-px, 0.875rem) !important;
}
.multiselect-caret {
  margin: 0 0 0 var(--ms-px, 0.875rem) !important;
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem 0.5rem 2.7rem !important;
  background-position: left 0.9rem center !important;
}

.invalid-feedback {
  display: block !important;
}
</style>
